/*
 * @Descripttion:
 * @Date: 2024-08-06 10:12:42
 */
import http from '@/utils/http/axios';
import { wwwConfig } from '@/utils/http/axios/content-type';
import {
  ProjectDetail,
  AllDeptmentApi,
  AspSubmitApi,
  IndustryConfirmApi
} from '../types/index';
import { QueryDictServiceApi, VisitTargetTypeApi } from './types';

const yApiObj = {
  // yapi: 1263
};

enum Api {
  projectDetail = '/front-end/project/fe/index/detail', // 项目详情
  allDeptment = '/front-end/project/fe/index/allDeptment', // 查询所有科室
  zoneSelector = '/front-end/project/fe/index/zoneSelector', // 查询专区下拉框数据
  qualificationSelector = '/front-end/project/fe/index/qualificationSelector', // 资质信息下拉框

  areaList = '/front-end/project/fe/index/areaList', // 需求地点下拉框
  queryDictService = '/front-end/project/fe/index/queryDictService', // 场景分类查询
  visitTargetType = '/front-end/project/fe/index/visitTargetType', // 获取拜访目标类型
  bizDesc = '/front-end/project/fe/index/bizDesc', // 业务说明

  aspSubmit = '/front-end/project/fe/index/submit', // asp 提交项目信息
  aspNext = '/front-end/project/fe/index/next', // asp查询下一个项目的id
  industryConfirm = '/front-end/project/fe/index/industryConfirm', // 工业确认项目
  industryNext = '/front-end/project/fe/index/industryNext', // 工业查询下一个项目的id

  projectRiskInfo = '/front-end/project-risk/info/:projectId', // 项目风控详情（OSS后台查询）
  submitRiskInfo = '/front-end/project-risk/build/project/risk', //项目风控提交
  revisionRecord = '/front-end/project-risk/revision/record/:projectId', // 查询项目风控修改记录
  parkList = '/front-end/project/fe/index/parkList', // 园区
  parkAreaList = '/front-end/project/fe/index/parkAreaList', // 省市区
  modifyBeforeAspUnSubmitted = '/front-end/project/pair/modifyBeforeAspUnSubmitted', // 乙方提交审核之前关联表单和设置项目审核要求
  /** 更新项目名称和需求地点 */
  updateBaseInfo = '/front-end/project/pair/updateBaseInfo'
}

/**
 * 查询园区列表
 */
export const parkList = async params => {
  return http.request(
    {
      url: Api.parkList,
      method: 'GET',
      params
    },
    {
      ...yApiObj
    }
  );
};

/**
 * 省市区
 */
export const parkAreaList = async () => {
  return http.request(
    {
      url: Api.parkAreaList,
      method: 'GET'
    },
    {
      ...yApiObj
    }
  );
};

/**
 * 项目详情
 */
export const projectDetailApi: ({
  id
}: {
  id: number;
}) => GApiResult<ProjectDetail> = async params => {
  return http.request(
    {
      url: Api.projectDetail,
      method: 'GET',
      params
    },
    {
      ...yApiObj
    }
  );
};

/**
 * 需求地点下拉框
 */
export const areaListApi: (params?: {
  aspId?: number;
  industryId?: number;
}) => GApiResult<
  Array<{
    id: number;
    name: string;
    children: Array<{ id: number; name: string }>;
  }>
> = async params => {
  return http.request(
    {
      url: Api.areaList,
      method: 'GET',
      params
    },
    {
      ...yApiObj
    }
  );
};

/**
 * 查询专区下拉框数据
 */
export const zoneSelectorApi: (params: {
  name?: string;
  projectId: number;
  zoneEnterpriseType: 1 | 2;
}) => GApiResult<
  Array<{
    id: number;
    name: string;
  }>
> = async params => {
  return http.request(
    {
      url: Api.zoneSelector,
      method: 'GET',
      params
    },
    {
      ...yApiObj
    }
  );
};

/**
 * 查询资质信息
 */
export const qualificationSelectorApi: (params) => GApiResult<
  Array<{
    id: number;
    name: string;
  }>
> = async params => {
  return http.request(
    {
      url: Api.qualificationSelector,
      method: 'GET',
      params
    },
    {
      ...yApiObj
    }
  );
};

/**
 * 场景分类查询
 */
export const queryDictServiceApi: QueryDictServiceApi = async params => {
  return http.request(
    {
      url: Api.queryDictService,
      method: 'GET',
      params: { queryAll: 1, ...params }
    },
    {
      ...yApiObj
    }
  );
};

/**
 * 获取拜访目标类型
 */
export const visitTargetTypeApi: VisitTargetTypeApi = async params => {
  return http.request(
    {
      url: Api.visitTargetType,
      method: 'GET',
      params
    },
    {
      ...yApiObj
    }
  );
};

/**
 * 业务说明
 */
export const bizDescApi = async (params: { id: number }) => {
  return http.request(
    {
      url: Api.bizDesc,
      method: 'GET',
      params
    },
    {
      ...yApiObj
    }
  );
};

/** 查询所有科室 */
export const allDeptmentApi: AllDeptmentApi = async params => {
  return http.request(
    {
      url: Api.allDeptment,
      method: 'GET',
      params
    },
    {
      ...yApiObj
    }
  );
};

/** 乙方提交审核之前关联表单和设置项目审核要求 */
export const modifyBeforeAspUnSubmittedApi = async (params: {
  id: number;
  projectRequire: string;
  surveyId: number;
  surveyType: number;
  isCoverAspSurvey?: 0 | 1;
  oprType: 1 | 2;
}) => {
  return http.request(
    {
      url: Api.modifyBeforeAspUnSubmitted,
      method: 'POST',
      params
    },
    {
      ...wwwConfig,
      ...yApiObj
    }
  );
};

/** asp 提交项目信息 */
export const aspSubmitApi: AspSubmitApi = async params => {
  return http.request(
    {
      url: Api.aspSubmit,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );
};

/** asp查询下一个项目的id */
export const aspNextApi: (params: {
  curProjectId: number;
}) => GApiResult<number> = async params => {
  return http.request(
    {
      url: Api.aspNext,
      method: 'GET',
      params
    },
    {
      ...yApiObj
    }
  );
};

/** 工业确认项目 */
export const industryConfirmApi: IndustryConfirmApi = async params => {
  return http.request(
    {
      url: Api.industryConfirm,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );
};

/** 工业查询下一个项目的id */
export const industryNextApi: (params: {
  curProjectId: number;
}) => GApiResult<string> = async params => {
  return http.request(
    {
      url: Api.industryNext,
      method: 'GET',
      params
    },
    {
      ...yApiObj
    }
  );
};

/**
 * 获取项目风控详情
 */
export const revisionRecord = async (params: {
  projectId: number; //项目id
}): Promise<
  Result<
    {
      aspId: number; //企业ID
      projectId: number; //项目ID
      riskSource: string; //风控来源0向日葵平台1服务商
      ruleName: string; //风控项名称
      riskRuleOld: string; //编辑之前的数据
      riskRuleNew: string; //编辑之后的数据
      effectiveAt: string; //生效时间
      operatorBy: string; //操作人
      createAt: string; //创建时间
    }[]
  >
> =>
  http.request({
    url: Api.revisionRecord,
    method: 'GET',
    params
  });

/**
 * 获取项目风控详情
 */
export const projectRiskInfo = async (params: {
  projectId: number; //项目id
}): Promise<
  Result<{
    serviceRiskRuleDTOList: {
      id: number;
      baseRuleId: number; //基础规则id
      ruleName: string; //规则名称
      riskBaseRule: string; //JSON格式的风险规则配置选项
      isCheck: number; //是否勾选,0否,1是
    }[];
    platformRiskRuleDTOList: {
      id: number;
      baseRuleId: number; //基础规则id
      ruleName: string; //规则名称
      riskBaseRule: string; //JSON格式的风险规则配置选项
      isCheck: number; //是否勾选,0否,1是
    }[];
  }>
> =>
  http.request({
    url: Api.projectRiskInfo,
    method: 'GET',
    params
  });

/**
 * 获取项目风控详情
 */
export const submitRiskInfo = async (params: {
  projectId: number; //项目id
  riskBaseRuleRespDTOList: {
    id: number;
    baseRuleId: number; //基础规则id
    ruleName: string; //规则名称
    riskBaseRule: string; //JSON格式的风险规则配置选项
    isCheck: number; //是否勾选,0否,1是
  }[];
}) =>
  http.request({
    url: Api.submitRiskInfo,
    method: 'POST',
    params
  });

/**
 * 更新项目名称、需求地点（未导入人员）
 * POST /front-end/project/pair/updateBaseInfo，入参 id / projectName / areaIds 三个都传
 */
export const modifyProjectBaseApi = async (params: {
  id: number;
  projectName: string;
  areaIds: number[];
}) => {
  return http.request(
    {
      url: Api.updateBaseInfo,
      method: 'POST',
      params
    },
    {
      ...yApiObj
    }
  );
};
